import React, { createContext, useContext, PropsWithChildren } from 'react';

export type SignUpFormGlobalConfiguration = {
  readonly confirmationPageUrl: string;
  readonly checkEmailPageUrl: string;
  readonly newUserSignupRedirectUrl?: string;
};

export type SignUpFormGlobalConfigurationContextProps = {
  readonly confirmationPageUrl?: string;
  readonly checkEmailPageUrl?: string;
  readonly newUserSignupRedirectUrl?: string;
};

export const SignUpGlobalConfigurationContext =
  createContext<SignUpFormGlobalConfigurationContextProps>({});

export function SignUpGlobalConfigurationContextProvider({
  children,
  ...props
}: PropsWithChildren<SignUpFormGlobalConfigurationContextProps>) {
  return (
    <SignUpGlobalConfigurationContext.Provider value={props}>
      {children}
    </SignUpGlobalConfigurationContext.Provider>
  );
}

export function useSignUpFormGlobalConfiguration(): SignUpFormGlobalConfiguration {
  const { confirmationPageUrl, checkEmailPageUrl, newUserSignupRedirectUrl } =
    useContext(SignUpGlobalConfigurationContext);

  return {
    confirmationPageUrl:
      confirmationPageUrl ?? '/wac/ondemand/signup/confirmation',
    checkEmailPageUrl: checkEmailPageUrl ?? '/wac/ondemand/signup/checkemail',
    newUserSignupRedirectUrl: newUserSignupRedirectUrl
  };
}
